<template>

    <div class="progress-widget">
        <div class="media">
            <div class="media-left">
            <div class="progress" id="barraGris" :data-percentage="porciento">
              <span class="progress-left">
                <span class="progress-bar"></span>
              </span>
                <span class="progress-right">
                <span class="progress-bar"></span>
              </span>
                <div class="progress-value">
                    <div id="grafico">
                        {{ this.data }} %
                    </div>
                </div>
            </div></div>
            <div class="media-body">Información de tu perfil</div>
        </div>
        <p>Con tus Datos personales podremos optimizar aún más tus beneficios, <a @click="cambiarPagina('perfil')">completa tus datos aquí</a>.</p>
        </div>
</template>

<script>
    export default {
        name: "percentage",

        data: function() {
            var data = _.cloneDeep(this.percentage);
            return {
                data: data,
                porciento: null,
            }
        },
        props: ['percentage'],
        methods:{
            cambiarPagina: function (pagina)
            {
                window.location = '/mi-cha/' + pagina;
            }
        },
        beforeMount() {
            var resto = this.data % 10;
            this.porciento = this.data - resto;
        },
    }
</script>

<style scoped>

</style>